/*
  Writes landing context onto the Shopify cart so a later paid order can say where the
  visit started. No sessionStorage of our own, but the first /cart/update.js creates
  Shopify's cart cookie (treated as strictly necessary). GA client_id and session_id
  are written only after analytics consent.
  The server reports every paid order (services/api/app/domain/shop_attribution.py); with these ids
  the GA4 purchase joins the browsing session, without them it gets a one-off server id.
*/
(function () {
  'use strict';

  var host = window.location.hostname;
  var isLocal = host === 'localhost' || host === '127.0.0.1' || host.indexOf('192.168.') === 0;
  if (window.Shopify && window.Shopify.designMode) return;

  var current = window.tgCartAttr || {};
  var GA_ID = 'G-22C6QLTWEF';
  var GA_COOKIE = '_ga_22C6QLTWEF';

  function clip(value) {
    return String(value || '').slice(0, 500);
  }

  function param(name) {
    try {
      return new URLSearchParams(window.location.search).get(name) || '';
    } catch (e) {
      return '';
    }
  }

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|;\\s*)' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function idsFromCookies() {
    var ga = readCookie('_ga').split('.');
    var clientId = ga.length >= 4 ? ga[ga.length - 2] + '.' + ga[ga.length - 1] : '';
    var gs = readCookie(GA_COOKIE).split('.');
    var sessionId = gs.length >= 3 && /^\d+$/.test(gs[2]) ? gs[2] : '';
    return { clientId: clientId, sessionId: sessionId };
  }

  function patch(next) {
    var changed = {};
    Object.keys(next).forEach(function (key) {
      var value = clip(next[key]);
      if ((current[key] || '') === value) return;
      changed[key] = value;
    });
    if (!Object.keys(changed).length) return;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: changed }),
      keepalive: true
    }).then(function (res) {
      if (!res.ok) return;
      Object.keys(changed).forEach(function (key) {
        current[key] = changed[key];
      });
    }).catch(function () {});
  }

  function landing() {
    var next = {};
    if (!current._tg_land) {
      next._tg_land = window.location.pathname + window.location.search;
    }
    if (!current._tg_ref && document.referrer) {
      next._tg_ref = document.referrer;
    }
    if (!current._tg_in) next._tg_in = String(Math.floor(Date.now() / 1000));

    var campaign = {
      _tg_src: param('utm_source'),
      _tg_med: param('utm_medium'),
      _tg_cmp: param('utm_campaign'),
      _tg_cnt: param('utm_content'),
      _tg_trm: param('utm_term'),
      _tg_gclid: param('gclid'),
      _tg_fbclid: param('fbclid')
    };
    var hasCampaign = campaign._tg_src || campaign._tg_gclid || campaign._tg_fbclid;
    if (hasCampaign) {
      Object.keys(campaign).forEach(function (key) {
        next[key] = campaign[key];
      });
    }
    patch(next);
  }

  function consentCode(consent) {
    return 'a' + (consent.analytics ? '1' : '0') + 'm' + (consent.marketing ? '1' : '0');
  }

  function syncConsent(consent) {
    if (!consent.analytics) {
      patch({ _tg_consent: consentCode(consent), _tg_ga: '', _tg_sid: '' });
      return;
    }
    patch({ _tg_consent: consentCode(consent) });
    readGaIds(0);
  }

  function readGaIds(attempt) {
    var pending = { clientId: '', sessionId: '' };
    var left = 2;
    var finished = false;

    function finish() {
      if (!pending.clientId || !pending.sessionId) {
        var fromCookie = idsFromCookies();
        pending.clientId = pending.clientId || fromCookie.clientId;
        pending.sessionId = pending.sessionId || fromCookie.sessionId;
      }
      if (pending.clientId && pending.sessionId) {
        if (finished) return;
        finished = true;
        clearTimeout(timedOut);
        patch({ _tg_ga: pending.clientId, _tg_sid: pending.sessionId });
        return;
      }
      if (finished || attempt >= 3) return;
      finished = true;
      clearTimeout(timedOut);
      setTimeout(function () { readGaIds(attempt + 1); }, 400 * (attempt + 1));
    }

    function one() {
      left -= 1;
      if (left > 0) return;
      clearTimeout(timedOut);
      finish();
    }

    if (typeof window.gtag !== 'function') {
      finish();
      return;
    }
    var timedOut = setTimeout(finish, 800);
    try {
      window.gtag('get', GA_ID, 'client_id', function (id) {
        pending.clientId = id || '';
        one();
      });
      window.gtag('get', GA_ID, 'session_id', function (id) {
        pending.sessionId = id == null ? '' : String(id);
        one();
      });
    } catch (e) {
      clearTimeout(timedOut);
      finish();
    }
  }

  // Local theme dev (`shopify theme dev` uses the live cart and checkout) and owner devices
  // (?tg_internal=1) mark the cart, so their orders never reach GA4 and PostHog flags them.
  patch({ _tg_internal: isLocal || window.tgInternal ? '1' : '' });
  if (isLocal) return;

  landing();
  if (window.tgConsent) window.tgConsent.onChange(syncConsent);
})();
